<template>
    <form class="wrapper tab-name" role="form" method="post" @submit.prevent="submit" novalidate>
        <header>
            <span class="new-headline-md text-centered">Lernen wir uns kennen.</span>

            <p class="new-text-lg text-centered text-color-default">Wie heißen Sie?</p>
        </header>

        <div class="form-wrapper">
            <div class="col-2">
                <form-input-type-text
                    name="first_name"
                    label="Vorname"
                    :value="firstName"
                    :errors="errors.first_name"
                    full-border
                    required
                ></form-input-type-text>

                <form-input-type-text
                    name="last_name"
                    label="Nachname"
                    :value="lastName"
                    :errors="errors.last_name"
                    full-border
                    required
                ></form-input-type-text>
            </div>

            <div class="btn-group">
                <v-button type="submit" label="Weiter" full-width></v-button>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                required: false,
                default: null
            }
        },

        data() {
            const parts = (this.value || '').trim().split(/\s+/)

            return {
                firstName: parts.shift() || '',
                lastName: parts.join(' '),
                errors: {}
            }
        },

        methods: {
            submit() {
                const firstName = ($('#first_name').val() || '').trim()
                const lastName = ($('#last_name').val() || '').trim()

                this.errors = {}

                if (!firstName) {
                    this.$set(this.errors, 'first_name', ['Bitte tragen Sie Ihren Vornamen ein.'])
                }

                if (!lastName) {
                    this.$set(this.errors, 'last_name', ['Bitte tragen Sie Ihren Nachnamen ein.'])
                }

                if (!firstName || !lastName) {
                    Vuemit.fire('Button--sending-failed', true)

                    return
                }

                this.$emit('answer', firstName + ' ' + lastName)
            }
        }
    }
</script>
